import React, { Fragment, useEffect, useState } from "react";
import ProfileBar from "./components/ProfileBar";
import PageTitle from "./components/PageTitle";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import { fetchData } from "./js/main";
import { Icon, IconButton, TextField } from "@mui/material";

export default function Account(props) {
  return (
    <div className="content">
      <ProfileBar profile={props.profile} />
      <PageTitle page={props.page} />
      <AccountTable />
    </div>
  );
}

function AccountTable() {
  const [accounts, setAccounts] = useState();
  useEffect(() => {
    (async () => {
      let acc = await fetchData("post", "/collection/accounts", {
        sort: { chart_code: 1 },
        limit: 0,
      });
      setAccounts(acc);
    })();
  }, []);
  function editAccount(key) {
    let Acc = JSON.parse(JSON.stringify(accounts));
    Acc.result[key].edit = !Acc.result[key].edit;
    setAccounts(Acc);
  }
  async function save(form) {
    let Acc = await fetchData("put", "/v3/account", form);
    let newAccounts = JSON.parse(JSON.stringify(accounts));
    let key = newAccounts.result.findIndex((j) => j._id === Acc._id);
    if (key > -1) {
      newAccounts.result[key] = Acc;
      newAccounts.result[key].edit = false;
    } else {
      newAccounts.result.unshift(Acc);
    }
    setAccounts(newAccounts);
  }
  return (
    <div>
      {accounts && (
        <>
          <div className="bold">Result : {accounts.count} item(s)</div>
          <br />
          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ width: "60px" }}>No.</TableCell>
                  <TableCell sx={{ width: "130px" }}>Account Code</TableCell>
                  <TableCell sx={{ width: "120px" }}>Chart Code</TableCell>
                  <TableCell>Account Name</TableCell>
                  <TableCell>Biller Name</TableCell>
                  <TableCell sx={{ width: "80px" }}>Disabled</TableCell>
                  <TableCell sx={{ width: "60px" }}>Edit</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <ShowEditItemRow onSave={save} />
                {accounts.result.map((account, key) => (
                  <Fragment key={key}>
                    {account.edit === true ? (
                      <ShowEditItemRow
                        account={account}
                        onEdit={() => editAccount(key)}
                        onSave={save}
                      />
                    ) : (
                      <ShowItemRow
                        account={account}
                        no={key + 1}
                        onEdit={() => editAccount(key)}
                      />
                    )}
                  </Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </div>
  );
}

function ShowItemRow({ no, account, onEdit }) {
  return (
    <TableRow>
      <TableCell align="center">{no}</TableCell>
      <TableCell align="center">{account.account_code}</TableCell>
      <TableCell align="center">{account.chart_code}</TableCell>
      <TableCell>{account.account_name}</TableCell>
      <TableCell>{account.biller_name}</TableCell>
      <TableCell align="center">
        {account.disabled === true && <Icon>done</Icon>}
      </TableCell>
      <TableCell className="noPadding" align="center">
        <IconButton color="primary" onClick={onEdit}>
          <Icon>edit</Icon>
        </IconButton>
      </TableCell>
    </TableRow>
  );
}

function ShowEditItemRow({ account, onEdit, onSave }) {
  const [form, setForm] = useState({});
  useEffect(() => {
    if (account) setForm(account);
    else setForm({});
  }, [account]);
  return (
    <TableRow>
      <TableCell className="noPadding" align="center">
        <IconButton color="success" onClick={onEdit}>
          <Icon>undo</Icon>
        </IconButton>
      </TableCell>

      {account ? (
        <TableCell align="center">{form.account_code}</TableCell>
      ) : (
        <TableCell className="inputPadding">
          <TextField
            fullWidth
            size="small"
            InputProps={{ style: { fontSize: ".9rem" } }}
            value={form.account_code || ""}
            onChange={(e) => setForm({ ...form, account_code: e.target.value })}
          />
        </TableCell>
      )}
      {account ? (
        <TableCell align="center">{form.chart_code}</TableCell>
      ) : (
        <TableCell className="inputPadding">
          <TextField
            fullWidth
            size="small"
            InputProps={{ style: { fontSize: ".9rem" } }}
            value={form.chart_code || ""}
            onChange={(e) => setForm({ ...form, chart_code: e.target.value })}
          />
        </TableCell>
      )}

      <TableCell className="inputPadding">
        <TextField
          fullWidth
          size="small"
          InputProps={{ style: { fontSize: ".9rem" } }}
          value={form.account_name || ""}
          onChange={(e) => setForm({ ...form, account_name: e.target.value })}
        />
      </TableCell>
      <TableCell className="inputPadding">
        <TextField
          fullWidth
          size="small"
          InputProps={{ style: { fontSize: ".9rem" } }}
          value={form.biller_name || ""}
          onChange={(e) => setForm({ ...form, biller_name: e.target.value })}
        />
      </TableCell>
      <TableCell className="noPadding" align="center">
        <Checkbox
          checked={form.disabled || false}
          onChange={(e, value) => setForm({ ...form, disabled: value })}
        />
      </TableCell>
      <TableCell className="noPadding" align="center">
        <IconButton
          color="success"
          onClick={() => {
            onSave(form);
            if (!account) setForm({});
          }}
        >
          <Icon>save</Icon>
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
